import React, { Component } from 'react';
// import * as firebase from 'firebase';
// import AuthActions from './store/actions/authActions';
// import ErrorActions from './store/actions/errorActions';
// import AuthMiddleware from './store/middleware/authMiddleware';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { connect } from 'react-redux';
import AuthActions from '../../store/actions/authActions';
import ErrorActions from '../../store/actions/errorActions';
import AuthMiddleware from '../../store/middleware/authMiddleware';
import RouteActions from '../../store/actions/routeActions';
import { withRouter } from 'react-router-dom';
// import history from './History'
// import RouteActions from './store/actions/routeActions';
// import { withRouter } from 'react-router-dom';


class Appbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutPopup: false,
      logoutPopupOpen: false,
    };
    props.routes(props.history);
    // console.log(props.history);

  }



  handleClick = event => {
    const { currentTarget } = event;
    this.setState(state => ({
      logoutPopup: !state.logoutPopup,
      logoutPopupOpen: this.state.logoutPopupOpen ? false : true,
      anchorEl: currentTarget,
    }));
  };


  componentDidMount() {
    // this.props.routes(history);
    // console.log(history);
  }
  popperClose() {
    this.setState({
      logoutPopup: false
    })
  }
  

  

  callme123(){
    let path = window.location.pathname
    if(path=='/quiz/start'){
      this.setState({
        showDialog:true,
        confirmPopup: true
      })
    }
    else{
      if(this.props.appHistory){
        if(localStorage.getItem('panaCloudId')){
          this.props.appHistory.push(`/home/${localStorage.getItem('panaCloudId')}`)  
        }  
        else{
          this.props.appHistory.push(`/`); 
        }
      }
      else{
        window.location.replace('/');
      }
    }
  }

  
  render() {
    const { anchorEl, logoutPopup } = this.state;
    return (
        <div>
          {!this.props.onSlashRoute && <div>
            {/* <AppBar> */}
            <AppBar style={{ backgroundColor: "#333333", borderBottom: "3px solid #13a89e" }}>
              <Toolbar style={{ justifyContent: "space-between" }}>
                <Button onClick={() => this.callme123()} style={{ color: "white", textTransform: "none", fontSize: "18px" }}>
                  K2
                </Button>
                {this.state.showDialog ?
                  <Dialog
                    open={this.state.confirmPopup}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to leave this page ?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                        No
                      </Button>
                      <Button onClick={this.handleCloseYes} color="primary" autoFocus>
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                  :
                  ""          
                }
                {this.props.loader ? "" :
                  <div>
                    {this.props.user && this.props.user.name ?
                      <Typography style={{ color: "white" }}>
                        <Button className='nameButton' variant="contained" color="primary" onClick={this.handleClick} style={{ backgroundColor: "#333333", textTransform: "none" }}>{this.props.user.name}
                          {this.state.logoutPopupOpen ? <ExpandLess /> : <ExpandMore />}
                        </Button>
                        <IconButton className='menuButton' color="inherit" aria-label="Menu" onClick={this.handleClick}>
                          <MenuIcon />
                        </IconButton></Typography>
                      :
                      <Typography>
                        {/* { <Button variant="contained" color="primary" style={{height : "50px", textTransform : "none", marginRight : "10px"}}>
                        <Link to={{pathname : '/signin'}} style={{textDecoration : "none", color : "#fff"}}>
                        Sign In With Email Password
                        </Link>
                        </Button> } */}
                        {
                        /*  
                        <Button variant="contained" color="primary" style={{textTransform : "none"}} onClick={() => { this.props.fbsignin(); this.props.clearstate() }} >
                        <img src={Images.fbIcon} width="30" height="30" style={{ marginRight: "5px" }} />
                        Sign In With Facebook</Button>
                        */
                        }
                        {/* <Link to={{pathname : '/signup'}} style={{textDecoration : "none"}}><Button variant="contained" color="primary">Sign Up</Button></Link> */}
                      </Typography>
                    }
                  </div>}
                <Popper open={logoutPopup} anchorEl={anchorEl} style={{ zIndex: 1101 }} transition placement={"bottom-end"}>
                  {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350} style={{ marginLeft: "-28%", textAlign: "center", borderRadius: "0", boxShadow: "1px 5px 25px 0px #888" }}>
                      <Paper>
                        <Button onClick={() => {this.props.logout(); /*this.props.fblogout();*/ this.popperClose(); localStorage.removeItem('proctoringKey'), localStorage.removeItem('token'), localStorage.removeItem('courseName'), localStorage.removeItem('panaCloudId'), localStorage.removeItem('user') }} style={{ padding: "10px 30px", cursor: "pointer" }}>LOGOUT</Button>
                      </Paper>
                    </Fade>
                  )}
                </Popper>
              </Toolbar>
            </AppBar>
          </div>
}
          
        </div>
    );
  }
}
function mapStateToProps(state) {
  // console.log(state)
  return {
    user: state.authReducer.user,
    loader: state.authReducer.isLoading,
    verifyProctoringKey: state.quizReducer.proctoringKey,
    appHistory: state.routeReducer.appHistory,
    onSlashRoute: state.SlashRouteReducer.onSlashRoute,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    clearstate: () => { dispatch(AuthActions.ClearState()) },
    buttonDisable: () => { dispatch(ErrorActions.ButtonDisable()) },
    buttonEnable: () => { dispatch(ErrorActions.ButtonEnable()) },
    token: (response) => { dispatch(AuthMiddleware.accessTokenMiddleware(response)) },
    fblogout: () => dispatch(AuthMiddleware.fblogoutMiddleware()),
    fbsignin: () => { dispatch(AuthMiddleware.fbsigninMiddleware()) },
    routes : (history) => { dispatch(RouteActions.AppRoute(history))},
    logout: () => dispatch(AuthActions.Logout()),    
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Appbar));




// WEBPACK FOOTER //
// ./src/container/Appbar/Appbar.js